import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Checkbox } from '@/components/ui/checkbox';

export default function Step5SampleCollection({ formData, updateFormData }) {
  const handleSampleChange = (field, value) => {
    updateFormData({
      ...formData,
      sample_collection: {
        ...formData.sample_collection,
        [field]: value,
      },
    });
  };

  const toggleCheckbox = (field, value) => {
    const current = formData.sample_collection[field] || [];
    const newValues = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    handleSampleChange(field, newValues);
  };

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-heading font-bold text-slate-900 mb-2">
          Método de Recolección y Conservación
        </h2>
        <p className="text-slate-600">
          Especifique el método utilizado para cada tipo de muestra
        </p>
      </div>

      {/* Sangre */}
      <div className="bg-slate-50 p-6 rounded-lg space-y-4 border border-slate-200">
        <h3 className="font-heading font-semibold text-lg text-slate-900">
          Sangre
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 checkbox-group">
          {['Jeringa', 'Sistema de vacío', 'Muestra tomada de catéter'].map((item) => (
            <label key={item} className="flex items-center gap-2">
              <Checkbox
                data-testid={`sangre-${item.toLowerCase().replace(/\s/g, '-')}`}
                checked={(formData.sample_collection.sangre || []).includes(item)}
                onCheckedChange={() => toggleCheckbox('sangre', item)}
              />
              <span className="text-sm text-slate-700">{item}</span>
            </label>
          ))}
        </div>
        <div className="space-y-2">
          <Label htmlFor="sangre_otra" className="font-medium text-slate-700">
            Otra
          </Label>
          <Input
            id="sangre_otra"
            data-testid="sangre-otra-input"
            placeholder="Especifique otro método..."
            value={formData.sample_collection.sangre_otra || ''}
            onChange={(e) => handleSampleChange('sangre_otra', e.target.value)}
            className="h-11"
          />
        </div>
      </div>

      {/* Orina */}
      <div className="bg-slate-50 p-6 rounded-lg space-y-4 border border-slate-200">
        <h3 className="font-heading font-semibold text-lg text-slate-900">
          Orina
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 checkbox-group">
          {['Cistocentesis traumática', 'Cistocentesis no traumática', 'Sondaje uretral', 'Micción espontánea'].map((item) => (
            <label key={item} className="flex items-center gap-2">
              <Checkbox
                data-testid={`orina-${item.toLowerCase().replace(/\s/g, '-')}`}
                checked={(formData.sample_collection.orina || []).includes(item)}
                onCheckedChange={() => toggleCheckbox('orina', item)}
              />
              <span className="text-sm text-slate-700">{item}</span>
            </label>
          ))}
        </div>
        <div className="space-y-2">
          <Label htmlFor="orina_otra" className="font-medium text-slate-700">
            Otra
          </Label>
          <Input
            id="orina_otra"
            data-testid="orina-otra-input"
            placeholder="Especifique otro método..."
            value={formData.sample_collection.orina_otra || ''}
            onChange={(e) => handleSampleChange('orina_otra', e.target.value)}
            className="h-11"
          />
        </div>
      </div>

      {/* Hisopados/Tejidos/Exudados */}
      <div className="bg-slate-50 p-6 rounded-lg space-y-4 border border-slate-200">
        <h3 className="font-heading font-semibold text-lg text-slate-900">
          Hisopados / Tejidos / Exudados
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 checkbox-group">
          {['Stuart', 'Amies', 'Solución salina fisiológica 0.9%', 'Seco estéril', 'Refrigerado'].map((item) => (
            <label key={item} className="flex items-center gap-2">
              <Checkbox
                data-testid={`hisopados-${item.toLowerCase().replace(/\s/g, '-').replace(/[.%]/g, '')}`}
                checked={(formData.sample_collection.hisopados || []).includes(item)}
                onCheckedChange={() => toggleCheckbox('hisopados', item)}
              />
              <span className="text-sm text-slate-700">{item}</span>
            </label>
          ))}
        </div>
        <div className="space-y-2">
          <Label htmlFor="hisopados_otra" className="font-medium text-slate-700">
            Otra
          </Label>
          <Input
            id="hisopados_otra"
            data-testid="hisopados-otra-input"
            placeholder="Especifique otro método..."
            value={formData.sample_collection.hisopados_otra || ''}
            onChange={(e) => handleSampleChange('hisopados_otra', e.target.value)}
            className="h-11"
          />
        </div>
      </div>

      {/* Observaciones */}
      <div className="space-y-2">
        <Label htmlFor="observaciones_conservacion" className="font-medium text-slate-700">
          Observaciones sobre la conservación de la muestra
        </Label>
        <Textarea
          id="observaciones_conservacion"
          data-testid="observaciones-conservacion-textarea"
          placeholder="Especifique condiciones de almacenamiento, temperatura, tiempo de transporte, etc."
          value={formData.sample_collection.observaciones_conservacion || ''}
          onChange={(e) =>
            handleSampleChange('observaciones_conservacion', e.target.value)
          }
          rows={4}
        />
      </div>
    </div>
  );
}